import { AspectRatio } from '@livecontrol/core-ui';

export const Iframe = ({ src }: { src: string }): React.ReactElement => (
  <div className='flex-grow-1'>
    <AspectRatio ratio={16 / 9}>
      <iframe src={src} style={{ width: '100%', height: '100%' }} title='mux dashboard.' />
    </AspectRatio>
  </div>
);
